<template>
	<div>
		<template v-if="studentSearchFilters">
			<div class="row">
				<div class="col">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="filter.programme">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme"
							>{{ programme.Name}}
							</option>
						</select>
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="filter.year">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="filter.programme">
								<option
								v-for="year in parseInt(filter.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(filter.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="filter.group">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<label>{{ $t("firm") }}</label>
						<select class="form-control" v-model="filter.firm">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('firms')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</template>

		<div class="row">
			<div class="col">
				<div class="input-group input-group mb-3">
					<input
						type="search"
						v-model="searchTerm"
						class="form-control"
						id="selector-search"
						data-cy="selector-search"
						:placeholder="placeholder"
						:maxlength="newValueMaxLength"
					/>
					<div class="input-group-append" v-if="newBtn">
						<button class="btn btn-primary" @click="newBtnClick" :disabled="newBtnDisabled">
							{{ $t("new") }}
						</button>
					</div>
				</div>
			</div>
			<div v-if="selectAllBtn" class="col-auto">
				<button class="btn btn-success" @click="selectAll" :disabled="selectAllBtnDisabled">
					{{ $t("select-all") }}
				</button>
			</div>
		</div>

		<div class="data-search-results row" data-cy="selector-results">
			<div v-for="(result, index) in results" :key="index" class="col-6 col-lg-4">
				<a
					href="#"
					@click.prevent="selectItem(result)"
					:class="getResultClass(result)"
					:data-cy="`selector-item-${index}`"
				>
					{{ (typeof result == 'object') ? result[captionKey] : result }}
					<template v-if="subcaptionKey"> <br />{{ result[subcaptionKey] }} </template>
					<b-icon icon="check-circle-fill" v-if="isActive(result)"></b-icon>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			searchTerm: "",
			filter: {
				programme: null,
				year: null,
				group: null,
				firm: null
			}
		};
	},
	props: {
		modalSettings: Object,
	},
	mounted() {
		this.$el.querySelector('#selector-search').focus();
	},
	methods: {
		selectAll() {
			for(let result of this.results) {
				this.selectItem(result);
			}
		},
		selectItem(item) {
			this.modalSettings.selectCallback(item);
		},
		getResultClass(result) {
			if (this.isActive(result)) {
				return "data-search-result data-search-result--active";
			}
			return "data-search-result";
		},
		isActive(result) {
			return this.modalSettings.selected.find(
				(item) => (item /* null check */ && typeof item == 'object' ? item[this.idProperty] : item) === (result /* null check */  && typeof result == 'object' ? result[this.idProperty] : result)
			);
		},
		getSearchTerm() {
			return this.searchTerm;
		},
		newBtnClick() {
			if (typeof this.newCallback === "function") {
				this.newCallback(this.searchTerm);
			}
			this.$store.commit("closeModal");
		},
	},
	computed: {
		newBtnDisabled() {
			return (this.newValueMinLength && this.searchTerm.length < this.newValueMinLength) ? true : null // use null values for conditional attributes;
		},
		selectAllBtnDisabled() {
			return this.results.length ? null : true;
		},
		results() {
			return this.modalSettings.data.filter((item) => {

				if(this.studentSearchFilters) {

					if(this.filter.programme && item.programme != this.filter.programme.Id) {
						return false;
					}
					if(this.filter.year && item.year != this.filter.year) {
						return false;
					}
					if(this.filter.group && item.group != this.filter.group) {
						return false;
					}
					if(this.filter.firm && item.firm != this.filter.firm) {
						return false;
					}
				}

				if(this.searchTerm) {
					const searching = item /* null check */ && typeof item == 'object' ? [item[this.captionKey], item[this.subcaptionKey]].filter(Boolean).join(' ') : item;
					return searching && searching.toLowerCase().includes(this.searchTerm.toLowerCase());
				}

				return true;

			});
		},
		captionKey() {
			return this.modalSettings.captionKey;
		},
		subcaptionKey() {
			return this.modalSettings.subcaptionKey;
		},
		newBtn() {
			return this.modalSettings.newBtn;
		},
		newValueMinLength() {
			if(!this.modalSettings.newValueMinLength || this.modalSettings.newValueMinLength == '0') {
				return undefined;
			}
			return this.modalSettings.newValueMinLength;
		},
		newValueMaxLength() {
			if(!this.modalSettings.newValueMaxLength || this.modalSettings.newValueMaxLength == '0') {
				return undefined;
			}
			return this.modalSettings.newValueMaxLength;
		},
		newCallback() {
			return this.modalSettings.newCallback;
		},
		placeholder() {
			return this.modalSettings.placeholder ? this.modalSettings.placeholder : this.$t('search-ellipses');
		},
		studentSearchFilters() {
			return this.modalSettings.studentSearchFilters;
		},
		selectAllBtn() {
			return this.modalSettings.selectAllBtn;
		},
		idProperty() {
			return this.modalSettings.idProperty ? this.modalSettings.idProperty : 'id';
		}
	},
};
</script>
